// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { CheckboxGroup, GridContainer, GridItem } from "@insite/mobius/index";
import { CustomWidgetModule } from "@store/Framework/Types/types";
import BunzlToggle from "@store/Library/Components/Bunzl/Common/BunzlToggle";
import BuyingListDisplay from "@store/Library/Widgets/BuyingList/BuyingListDisplay";
import React, { useEffect } from "react";
import { css } from "styled-components";

const AddListToUser: React.FC = () => {
    const user = useAppSelector(state => state.pages.userSetup.editingUser);
    const isUserAdmin = user?.role?.toLowerCase()?.includes("admin");
    const userHasLoaded = user?.id !== undefined;
    const initialHasBuyingList = user?.properties?.hasRestrictedBuyingList?.toLowerCase() === "true";
    const [hasBuyingList, setHasBuyingList] = React.useState(false);
    useEffect(() => {
        setHasBuyingList(initialHasBuyingList);
    }, [initialHasBuyingList]);
    const showToggle = !isUserAdmin && userHasLoaded;
    if (!showToggle) {
        return null;
    }
    return (
        <GridContainer
            css={css`
                padding: 1rem;
            `}
            data-test-selector="addListToUser_container"
        >
            <GridItem width={12} data-test-selector="addListToUser_toggleSection">
                <CheckboxGroup data-test-selector="addListToUser_checkboxGroup">
                    <BunzlToggle isToggled={hasBuyingList} setIsToggled={setHasBuyingList} />
                </CheckboxGroup>
            </GridItem>
            {hasBuyingList && <BuyingListDisplay />}
        </GridContainer>
    );
};

const WidgetModule: CustomWidgetModule<any> = {
    component: AddListToUser,
    definition: {
        group: "Buying List",
        displayName: "Add List To User",
    },
};

export default WidgetModule;
